import type { Messages } from "../fr";

export const api: Messages["api"] = {
  signIn: "Please log in.",
  unauthorized: "Not authorized.",
  invalidData: "Invalid data.",
  invalidRequest: "Invalid request.",
  offerNotFound: "Offer not found.",
  invalidAddress: "Invalid address.",
  originRefused: "Origin not allowed.",
  tooManyAttempts: "Too many attempts. Try again in a few minutes.",
  auth: {
    enterEmailAndPassword: "Enter your email and password.",
    wrongCredentials: "Incorrect email or password.",
    enterEmail: "Enter your email.",
    emailNotSent: "The email could not be sent. Try again later.",
    resetLinkInvalid: "This link is invalid or has expired. Request a new one.",
    signInToChangePassword: "Log in to change your password.",
    googleNotConfigured: "Google sign-in is not set up on this server.",
    googleLinkInvalid: "The Google sign-in link is invalid or has expired.",
    googleFailed: "Google sign-in failed. Try again.",
    invalidEmail: "Invalid email address.",
    passwordTooShort: (min: number) => `Your password must be at least ${min} characters long.`,
    passwordTooLong: "Your password is too long (72 bytes at most).",
    emailTaken: "An account already exists with this address.",
    invalidProfileValue: "Invalid profile value.",
    unknownProfileField: (key: string) => `Unknown profile field: ${key}.`,
    googleUnverified: "Google has not verified this email address.",
  },
  runs: {
    invalidId: "Invalid identifier.",
    signIn: "Log in to follow an analysis.",
    notFound: "Analysis not found.",
    stale: "The pass was interrupted before it finished. Run it again.",
  },
  analyze: {
    signIn: "Log in to run an analysis.",
    // The detail from shared/lib/llm.ts is French: the English message stands on its own.
    modelUnavailable: () => "The AI model key is missing on this server. Add it to .env.local or use the demo.",
    noOffer: "No offer to analyze: add one from “My offers”.",
    alreadyRunning: "A pass is already running on this offer.",
    cooldown: (hours: number) =>
      `The last pass on this offer ran less than ${hours} hours ago: the agent would not find any new signal.`,
    runNotSaved: "The pass could not be saved. Try again in a moment.",
    startFailed: "The analysis could not start.",
  },
  billing: {
    unknownPlan: "Unknown plan.",
    invalidCheckoutSession: "Invalid payment session.",
    unavailable: "Online payment is not available yet. Write to us.",
    planNames: { free: "Free", solo: "Solo", pro: "Pro" },
    limits: {
      maxOffers: (plan: string, max: number) =>
        max === 1
          ? `The ${plan} plan tracks a single offer. Upgrade to Solo to track more.`
          : `The ${plan} plan tracks ${max} offers at most. Archive one or change plans.`,
      manualRuns:
        "On the Free plan, monitoring runs a pass on your offer every month. Upgrade to Solo to run a pass whenever you want.",
      noSubscription: "No subscription to manage: choose a plan first.",
    },
  },
  feedback: {
    signIn: "Log in to give your feedback.",
    runNotFound: "Analysis not found.",
    organizationUnknown: "This organization is not in memory.",
  },
  linkPreview: {
    pageStatus: (status: number) => `The page responded ${status}.`,
  },
  track: {
    invalidEvent: "Invalid event.",
  },
};
